import { Environment, baseEnv } from './environment.base';

export const emiratesEnv = Object.assign(baseEnv, {
  seatsioWorkSpaceKey: 'd0b9c9be-aa52-4f91-ab96-a24f46a03d24',
  stripeKey:
    'pk_live_51J7ajwH5Xks8TpTwP63YHH6pn9acYCAVx6kIJ89Hes7bPYNuAH0zuX9cnNam5x2h3qNRla8Imn2BUNMxL2YQ8XNl00GZFLqIAN',
  teamPaymentOpensAtUtc: '2026-05-01 05:00:00',
  teamPaymentOpensAtDubaiTime: '2026-05-01 09:00:00',
  modules: ['team-payments', 'discounts', 'team-registration'],
  paymentSetup: {
    taxNumberInputLabel: 'UAE Tax Registration Number',
    taxNumberRequiredMin: 10000,
  },
  platformConfigs: [
    {
      domain: 'tickets.emiratesdubai7s.com',
      api: 'https://api.emiratesdubai7s.com/api/v2',
      token: 'cQPECtyAhND5',
    },
  ],
  chatbotUrl: 'https://bots.adviserally.com/m/0bdd52b90bd0eb42a069ab28afa2dcb8',
});

export const environment: Environment = emiratesEnv;
